// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__3cKiy","calendarButtons":"ClockData_calendarButtons__3VLYP"};